export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9458.1c8b4851.jpg";